const keys = {
  core: {
    products: {
      insurance: 'Insurance',
      name: {
        car: 'car',
        home: {
          condo: 'condo',
          homeowner: 'homeowner',
          tenant: 'tenant',
        },
      },
      type: {
        car: 'car',
        home: 'home',
      },
    },
    components: {
      expandableDropdown: {
        dialog: {
          title: 'Select your choice',
          searchPlaceHolderText: 'Search for an answer',
          noOptionFound: 'No option found',
        },
      },
      loadMoreResults: {
        loadMore: 'Load more results',
        maxRows: 'Max items reached. To load more results, contact the product team.',
        fullyLoaded: 'No more item to load',
      },
    },
  },
  incognito: {
    description: 'Please turn on your browser cookies.',
    title: 'We need cookies to work properly',
  },
  measurementSystem: {
    imperial: 'ft',
    metric: 'm',
  },
  notSupported: {
    description:
      'Unfortunately your browser is currently not supported. You can use Google Chrome, Safari, Microsoft Edge or Firefox to access all our great features.',
    title: 'Browser not Supported',
  },
  numeric: {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'height',
    9: 'nine',
  },
  underMaintenance: {
    description: 'Sorry, the site is down for a bit of maintenance right now. We will be back very soon.',
    title: 'Maintenance',
  },
  languages: {
    en: 'english',
    fr: 'français',
  },
  unknownError: {
    headline: 'Error!',
    title: 'An unknown error occured.',
    subtitle: 'Any suggestion of what to be done?',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
